import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { BasePagingResponse } from "../_types";

export type GetListSettlementByDateRequest = {
  page?: number;
  size?: number;
  orderByDesc?: boolean;
  orderBy?: string;
  filters: [],
  paymentMerchantDate: string
};

export type GetListSettlementByDate = BasePagingResponse<Array<any>>;

async function getListSettlementByDate(
  data: GetListSettlementByDateRequest
): Promise<any> {
  try {
    return (await axiosInstance.post("/Reconciliation/ListSettlementByDate", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetListSettlementByDate() {
  return useMutation<GetListSettlementByDate, Error, GetListSettlementByDateRequest>((variables) =>
    getListSettlementByDate(variables)
  );
}


